import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { useCallback, useRef, useState } from 'react';

import Slider from 'react-slick';
import cx from 'classnames';
import { navigate } from 'gatsby';
import useIsMobile from '../../hooks/useIsMobile';

const HeroCarousel = ({ content }) => {
	const [activeSlider, setActiveSlider] = useState(0);
	const slider = useRef(null);
	const isMobile = useIsMobile();

	const regex = /https?:\/\/[^\s]+/;
	const found = content
		.split('<figure')
		.map((text) => {
			const url = text.match(regex);
			if (url) {
				return url[0].replace(/-\d+x\d+(?=\.)/, '');
			}
		})
		.filter(Boolean);

	const settings = {
		dots: true,
		infinite: true,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1, // important for clickable dots
		slidesToScroll: 1, // move 1 slide per click
		arrows: false,
		fade: true
	};

	const images_mobile = [
		{
			url: found.find((el) => el.includes('4-mobile')),
			title: 'dovedi priqtel',
			linkTo: '/promocii/dovedi-priqtel/'
		},
		{
			url: found.find((el) => el.includes('2-mobile')),
			title: 'gpon',
			linkTo: '/kakvo-e-gpon/'
		},
		{
			url: found.find((el) => el.includes('3-mobile')),
			title: 'Za doma',
			linkTo: '/za-doma/'
		},
		{
			url: found.find((el) => el.includes('1-mobile')),
			title: 'Svoboda',
			linkTo: '/svoboda/'
		}
	];

	const images_desktop = [
		{
			url: found.find((el) => el.includes('4-desktop')),
			title: 'dovedi priqtel',
			linkTo: '/promocii/dovedi-priqtel/'
		},
		{
			url: found.find((el) => el.includes('1-desktop')),
			title: 'Svoboda',
			linkTo: '/svoboda/'
		},
		{
			url: found.find((el) => el.includes('2-desktop')),
			title: 'gpon',
			linkTo: '/kakvo-e-gpon/'
		},
		{
			url: found.find((el) => el.includes('3-desktop')),
			title: 'Za doma',
			linkTo: '/za-doma/'
		},
		{
			url: found.find((el) => el.includes('1-desktop')),
			title: 'Svoboda',
			linkTo: '/svoboda/'
		}
	];

	const data = isMobile ? images_mobile : images_desktop;

	const goToPage = useCallback(() => {
		navigate(data[activeSlider].linkTo);
	}, [activeSlider, data]);
	return (
		<div
			id="hero-carousel"
			className="container-lg relative additional-styles"
			style={{
				paddingTop: '10rem',
				overflow: 'hidden',
				maxWidth: 1400
			}}
		>
			<Slider {...settings} ref={slider} afterChange={(i) => setActiveSlider(i)}>
				{data.map((img, i) => (
					<div key={i} className="w-full relative">
						<img
							onClick={goToPage}
							src={img.url}
							alt={img.title}
							style={{
								maxWidth: '100%',
								height: 'auto',
								cursor: 'pointer'
							}}
						/>
					</div>
				))}
			</Slider>
			<span
				className={cx('arrow-next', {})}
				onClick={() => slider?.current?.slickNext()}
			/>
			<span
				className={cx('arrow-prev', {})}
				onClick={() => slider?.current?.slickPrev()}
			/>
		</div>
	);
};

export default HeroCarousel;

